import { uniqBy } from 'lodash-es'
export default {
  computed: {
    budgets () {
      return this.$store.getters['UsersStore/userBudgets'] || []
    },
    userIdForBudget () {
      if (
        this.transaction &&
        this.transaction.card &&
        this.transaction.card.user
      ) {
        return this.transaction.card.user.id
      }
      if (this.userId) {
        return this.userId
      }
      return false
    },
    userId () {
      return this.$store.getters['LoginStore/loggedUserId'] || 0
    }
  },
  methods: {
    generateBudgetList () {
      let allBudgets = [{ ...this.transaction.budget }, ...this.budgets]
      allBudgets = allBudgets.filter(item => item && item.id >= 0)
      let budgetsFormated = this._markBudgetsOptionAsArchived(allBudgets)

      if (this.budgetId) {
        budgetsFormated = this._filterArchivedBudgetsExceptSelectedArchivedBudget(
          budgetsFormated
        )
      }
      budgetsFormated = this._filterRetFlexBudgets(budgetsFormated)

      const budgetsSortedByDisabled = budgetsFormated.sort(
        (a, b) => a.$isDisabled - b.$isDisabled
      )

      const budgetsWithoutDuplicates = uniqBy(budgetsSortedByDisabled, 'id')

      return budgetsWithoutDuplicates
    },
    _markBudgetsOptionAsArchived (budgetList) {
      return budgetList.map(budget => {
        const budgetOption = budget.budget
          ? { ...budget.budget }
          : { ...budget }

        if (budgetOption.status && budgetOption.status.code === 'ARCHIVED') {
          budgetOption.$isDisabled = true
          budgetOption.name += ` - ${this.$i18n.t(
            'budgets_budget_status__ARCHIVED'
          )}`
        } else {
          budgetOption.$isDisabled = false
        }

        return budgetOption
      })
    },
    _filterArchivedBudgetsExceptSelectedArchivedBudget (budgetList) {
      return budgetList.filter(budget => {
        if (this.transaction && this.transaction.id && this.transaction.budget) {
          return (
            this.transaction.budget.id === budget.id ||
            budget.status.code === 'ACTIVE'
          )
        }
        return budget.status.code === 'ACTIVE'
      })
    },
    _filterRetFlexBudgets (budgetList) {
      return budgetList.filter(
        budget => budget.type?.code !== 'FLEXIBLE_REMUNERATION'
      )
    },
    async fetchCurrentTransactionUserBudgets () {
      let filters = {}
      filters = {
        'budget.status.code': ['ACTIVE'],
        'user.id[]': this.userIdForBudget,
        'isMember': true
      }
      if (this.transaction?.id) {
        filters['budget.status.code'].push('ARCHIVED')
      }
      await this.$store.dispatch('UsersStore/fetchUserBudgets', {
        page: 0,
        pagination: false,
        filters: filters
      })
    }
  }
}
